import type { DoctorDocumentsPayload } from 'src/components/common/DoctorDocumentsModal/types'
import type { LpuDoctor } from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/_components/LpuDoctorsList/types'

/**
 * Данные для модалки проверки документов врача.
 */
export default function getDoctorDocumentsPayload(
  doctor: LpuDoctor,
  linkToDocuments: string,
): DoctorDocumentsPayload {
  const payload: DoctorDocumentsPayload = {
    linkToDocuments,
    isEducationConfirmed: doctor.experience_data != null,
    isCategoryConfirmed: Boolean(doctor.category_document?.category),
    categoryExpiresDate: doctor.category_document?.valid_until || '',
    isCategoryExpiringSoon: doctor.category_document?.is_expire_soon ?? null,
    isCategoryValid: doctor.category_document?.is_valid ?? null,
    isScienceConfirmed: Boolean(doctor.science_data),
    scienceDocumentType: doctor.science_data ?? null,
  }

  if (doctor.fake_document_type_list?.length) {
    payload.fakeDocuments = doctor.fake_document_type_list
  }

  return payload
}
